<template>
  <section class="main">
    <div class="scroll-box">
      <div class="search-box">
        <input
          class="search"
          @keyup.enter="search"
          type="text"
          v-model="keyWords"
          placeholder="请输入关键字，如类型、风格、品牌等查找相关案例"
        />
        <i @click="search"></i>
      </div>

      <div class="hot-tag">
        <b>热门搜索：</b>
        <div class="tag-box">
          <a
            class="tag-item"
            @click="keyWords = item.name, search()"
            v-for="(item, index) in tagList"
            :key="index"
          >{{ item.name }}</a>
        </div>
      </div>

      <div class="list">
        <div class="filter-box">
          <div class="filter-item">
            <b>分类：</b>
            <div class="category-list data-list">
              <div
                class="category-item data-item"
                v-for="(item, index) in categoryList"
                :key="index"
                :class="{ active: index === categoryIndex }"
                @click="changeCategory(item, index)"
              >{{ item.menuName }}</div>
              <div class="second-category" v-show="secondCategoryList.length > 0">
                <div
                  class="category-item data-item"
                  v-for="(item, index) in secondCategoryList"
                  :key="index"
                  :class="{ active: index === secondCategoryIndex }"
                  @click="changeSecondCategory(index)"
                >{{ item.menuName }}</div>
              </div>
            </div>
          </div>
          <div class="filter-item last-child">
            <b>标签组：</b>
            <div class="category-list data-list">
              <div
                class="category-item data-item"
                @click="changeLabelGroup({}, 0)"
                :class="{ active: 0 === labelIndex }"
              >全部</div>
              <el-popover
                placement="bottom"
                width="400"
                v-model="item.show"
                v-for="(item, index) in labelGroupList"
                :key="index"
              >
                <div
                  slot="reference"
                  class="category-item data-item"
                  @click="changeLabelGroup(item, index + 1)"
                  :class="{ active: index + 1 === labelIndex }"
                >{{ item.group_name }}</div>
                <div class="label-list">
                  <div
                    class="label-item"
                    v-for="(it, idx) in item.labels"
                    :class="{ active: it.isActive }"
                    @click="changeLabel(it)"
                    :key="idx"
                  >{{ it.name }}</div>
                </div>
              </el-popover>
            </div>
          </div>
          <div class="filter">
            <div class="box">
              <b>创意更新时间：</b>
              <el-select
                :class="{ dark: isDark }"
                size="small"
                v-model="updateTime"
                @change="search"
                placeholder="请选择创意更新时间"
              >
                <el-option
                  v-for="(item, index) in timeList"
                  :key="index"
                  :value="index"
                  :label="item"
                >{{ item }}</el-option>
              </el-select>
              <b>创意类型：</b>
              <el-select
                :class="{ dark: isDark }"
                size="small"
                v-model="type"
                @change="search"
                placeholder="请选择创意类型"
              >
                <el-option
                  v-for="(item, index) in typeList"
                  :key="index"
                  :value="index"
                  :label="item"
                >{{ item }}</el-option>
              </el-select>
            </div>
            <p>共有{{ total }}条搜索结果</p>
          </div>
        </div>
        <div class="image-list">
          <waterfall
            :col="waterfallWidth"
            :width="216"
            :gutterWidth="20"
            :data="dataList"
            @loadmore="loadMore"
            :scrollObj="'.main'"
            :loadDistance="0"
          >
            <template>
              <div class="image-item" v-for="(item, index) in dataList" :key="index">
                <div class="image-box" @click="reviewImage(item, index)">
                  <img v-if="item.type === 0 || item.type === 2" :src="item.filePath" alt />
                  <img v-if="item.type === 1" :src="item.fileThumbnailPath" alt />
                  <img
                    src="../../assets/images/video-play-icon.png"
                    v-if="item.type === 1"
                    alt
                    class="video-play"
                  />
                </div>
                <div class="info">
                  <h3 class="title">
                    {{ item.fileName }}
                    <p v-show="false">
                      <i></i>
                      <span>12</span>
                    </p>
                  </h3>
                  <!-- <p class="desc">展示量估算：250k</p> -->
                  <div class="label-list" v-if="item.labels && item.labels.length > 0">
                    <div
                      class="label-item"
                      v-for="(it, idx) in item.labels"
                      :class="{ 'hot-tag': it.is_hot }"
                      :key="idx"
                    >{{ it.name }}</div>
                  </div>
                </div>
                <div class="share">
                  <p>--</p>
                  <!-- <i class="icon google"></i>
                  <i class="icon facebook"></i>-->
                  <p class="time">{{ item.createTime }}</p>
                </div>
              </div>
            </template>
          </waterfall>

          <div class="none" v-show="dataList.length === 0">
            <img src="../../assets/images/search-none.png" alt />
            <p>暂无搜索结果</p>
          </div>
        </div>
        <div class="loading" v-show="isLoading && dataList.length !== 0">
          <i class="el-icon-loading"></i>
        </div>
      </div>
    </div>

    <image-review
      :class="{ dark: isDark }"
      @close="closeReview"
      @toggleReview="toggleReview"
      @changeReview="changeReview"
      v-show="reviewShow"
      :item="reviewItem"
    ></image-review>
  </section>
</template>
<script>
import { PromiseWidget } from "../../assets/js/tools";
import ImageReview from "../../components/ImageReview";
import {
  getHotLabelList,
  getLabelGroupList,
  getCategoryList,
  getTypeList,
  getIndexList
} from "../../assets/js/api";
export default {
  components: { ImageReview },
  props: {
    isDark: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      isLoading: false,
      reviewShow: false,
      reviewItem: {},
      keyWords: "",
      tagList: [],
      categoryList: [],
      secondCategoryList: [],
      categoryIndex: -1,
      secondCategoryIndex: -1,
      waterfallWidth: 5,
      keyWords: "",
      labelGroupList: [],
      labelIndex: 0,
      updateTime: 4,
      timeList: ["过去7天", "过去14天", "过去30天", "过去90天", "历史所有"],
      type: 0,
      typeList: ["全部类型", "图片", "视频", "GIF"],
      total: 0,
      currentPage: 1,
      dataList: [],
      noMore: false
    };
  },
  watch: {
    reviewShow(val) {
      document.body.classList[val ? "add" : "remove"]("overflow");
    }
  },
  created() {
    this.getHotLabelList();
    this.getLabelGroupList();
    this.getCategoryList();
    // this.getTypeList();
    this.getIndexList();
  },
  methods: {
    emitReviewShow() {
      this.$emit("changeReview", this.reviewShow);
    },
    closeReview() {
      this.reviewShow = false;
      this.emitReviewShow();
    },
    reviewImage(item, index) {
      console.log(item)
      this.currentIndex = index;
      this.reviewItem = item;
      this.reviewShow = true;
      this.emitReviewShow();
    },
    changeReview(item) {
      this.reviewItem = item;
    },
    toggleReview(index) {
      this.currentIndex += index;
      this.currentIndex = Math.max(
        0,
        Math.min(this.currentIndex, this.dataList.length - 1)
      );
      if (this.currentIndex + 1 >= this.currentPage * 20) {
        this.currentPage++;
        this.getIndexList(this.currentIndex);
      } else {
        this.reviewItem = this.dataList[this.currentIndex];
      }
    },
    changeSecondCategory(index) {
      this.secondCategoryIndex = index;
      this.search();
    },
    changeLabel(item) {
      item.isActive = !item.isActive;
      this.search();
    },
    reviewImage(item, index) {
      console.log(item)
      this.currentIndex = index;
      this.reviewItem = item;
      this.reviewShow = true;
      this.emitReviewShow();
    },
    loadMore(data) {
      this.currentPage++;
      this.getIndexList();
    },
    async getIndexList(index) {
      const temp = [];
      this.labelGroupList[this.labelIndex - 1] &&
        this.labelGroupList[this.labelIndex - 1].labels &&
        this.labelGroupList[this.labelIndex - 1].labels.map(item => {
          item.isActive && temp.push(item.id);
        });
      const [err, data] = await PromiseWidget.to(
        getIndexList({
          page: this.currentPage,
          pageSize: 20,
          label: temp.join(","),
          time: this.updateTime,
          type: this.type,
          category:
            this.secondCategoryIndex > -1
              ? this.secondCategoryList[this.secondCategoryIndex].id
              : this.categoryList[this.categoryIndex]
              ? this.categoryList[this.categoryIndex].id
              : -1,
          keyWords: this.keyWords
        })
      );
      if (data.code === 200) {
        this.isLoading = data.data.data.length === 20;
        this.total = data.data.totalCount;
        this.noMore = data.data.data.length === 0;
        this.dataList =
          this.currentPage > 1
            ? this.dataList.concat(data.data.data)
            : data.data.data;
        this.noMore && this.$message.warning("没有更多数据了");
        if (index) {
          this.reviewItem = this.dataList[this.currentIndex];
        }
      }
    },
    changeLabelGroup(item, index) {
      this.labelGroupList.map(item => {
        item.show = false;
        item.labels &&
          item.labels.map(it => {
            it.isActive = false;
          });
      });
      this.labelIndex = index;
      if (index === 0) {
        this.getIndexList();
      }
      // this.search();
    },
    changeCategory(item, index) {
      this.categoryIndex = index;
      this.secondCategoryIndex = -1;
      this.secondCategoryList =
        this.categoryList[this.categoryIndex].menus || [];
      this.search();
    },
    async getCategoryList() {
      const [err, data] = await PromiseWidget.to(getCategoryList());
      if (data.code === 200) {
        data.data.unshift({ menuName: "全部", id: -1 });
        this.categoryList = data.data;
      }
    },
    async getLabelGroupList() {
      const [err, data] = await PromiseWidget.to(getLabelGroupList());
      if (data.code === 200) {
        data.data.map(item => {
          item.labels &&
            item.labels.map(it => {
              it.isActive = false;
            });
        });
        this.labelGroupList = data.data;
      }
    },
    async getHotLabelList() {
      const [err, data] = await PromiseWidget.to(getHotLabelList());
      if (data.code === 200) {
        this.tagList = data.data;
      }
    },
    search() {
      this.dataList = [];
      this.currentPage = 1;
      this.getIndexList();
    }
  }
};
</script>
<style lang="scss" scoped>
.creatives {
  &.white {
    .main {
      .search-box {
        input {
          color: #303133;
          background-color: #fff;
          border: 1px solid transparent;

          &::-webkit-input-placeholder {
            color: #c0c4cc;
          }
        }
      }

      .list {
        background-color: #fff;

        .filter-box {
          .filter-item.last-child {
            border-bottom-color: #dcdfe6;
          }
          .filter {
            p {
              color: #c0c4cc;
            }
          }
          border-bottom-color: #dcdfe6;
        }

        .image-list {
          .image-item {
            background-color: #fff;
            box-shadow: 0px 3px 10px rgba(16, 72, 132, 0.15);

            &:hover {
              background-color: #fff;
              box-shadow: 0px 6px 12px rgba(11, 75, 143, 0.2);
              transform: translateY(-1px);
              transition: all 0.5s;
            }
          }

          .info {
            border-bottom-color: #dcdfe6;
            h3.title {
              color: #303133;
            }

            .label-list {
              .label-item {
                background-color: #f5f5f5;
                color: #606266;
                border: 1px solid rgba(217, 217, 217, 1);
                border-radius: 4px;

                &.hot-tag {
                  color: #fff;
                  border-color: #ff6029;
                  background: linear-gradient(
                    135deg,
                    rgba(250, 213, 44, 1) 0%,
                    rgba(255, 96, 41, 1) 100%
                  );
                  position: relative;

                  &.active {
                    background: #fff;
                    color: #ff6029;
                    border-color: #ff6029;
                  }

                  &:after {
                    position: absolute;
                    right: -8px;
                    top: -7px;
                    content: " ";
                    width: 20px;
                    height: 14px;
                    background: url(../../assets/images/hot-tag-icon.png)
                      no-repeat center center;
                  }
                }
              }
            }
          }

          .share p {
            color: #c0c4cc;
          }
        }
      }
    }
  }

  .loading {
    padding-bottom: 20px;
  }

  .main {
    height: calc(100vh - 60px);
    overflow-y: auto;

    // &.blur {
    //   filter: blur(5px);
    // }
    .scroll-box {
      width: 1200px;
      padding: 30px 0 0;
      margin: 0 auto;
    }

    .search-box {
      position: relative;
      width: 600px;
      margin: 0 auto;
      input {
        width: 100%;
        height: 40px;
        border: 1px solid #353638;
        line-height: 38px;
        background-color: #353638;
        outline: none;
        text-indent: 20px;
        padding-right: 40px;
        font-size: 16px;
        color: #fff;
        box-sizing: border-box;
        &:hover,
        &:focus {
          border: 1px solid #1983f9;
        }
        &:-webkit-input-placeholder {
          color: #636366;
          font-size: 16px;
        }
      }
      i {
        display: block;
        width: 20px;
        height: 20px;
        background: url(../../assets/images/search-icon.png) no-repeat;
        position: absolute;
        right: 10px;
        top: 10px;
        content: " ";
        cursor: pointer;
      }
    }

    .hot-tag {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      width: 600px;
      margin: 10px auto 0;
      b {
        color: #909399;
        font-weight: 400;
        width: 85px;
      }
      .tag-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        width: 515px;
        a.tag-item {
          color: #606266;
          margin: 0 0 6px 10px;
          cursor: pointer;
          &:hover {
            color: #fff;
          }
        }
      }
    }

    .list {
      width: 100%;
      background-color: #1f2022;
      margin-top: 30px;
      .filter-box {
        padding: 20px 30px;
        border-bottom: 1px solid #343538;
        .filter-item {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          margin-bottom: 20px;
          &.last-child {
            margin-bottom: 0;
            padding-bottom: 20px;
            border-bottom: 1px dashed #343538;
          }
          b {
            width: 60px;
            margin-right: 10px;
            font-size: 14px;
            color: #c0c4cc;
            font-weight: 400;
            text-align: right;
            height: 22px;
            line-height: 22px;
          }

          .data-list {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: wrap;
            flex: 1;
            .second-category {
              width: 100%;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              flex-wrap: wrap;
              margin-top: 10px;
            }
            .data-item {
              margin: 0 10px 8px;
              padding: 0 16px;
              height: 22px;
              line-height: 22px;
              color: #909399;
              cursor: pointer;
              outline: none;
              &.active {
                color: #fff;
                background-color: #1983f9;
                border-radius: 5px;
                cursor: default;
              }
            }
          }
        }

        .filter {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 20px;
          b {
            margin-right: 16px;
            color: #909399;
            font-weight: 400;
          }
          .el-select {
            margin-right: 30px;
          }

          p {
            color: #606266;
            margin: 0;
          }
        }
      }

      .image-list {
        padding: 30px 0;
        .image-item {
          background-color: #27282a;
          margin-bottom: 20px;
          &:hover {
            background-color: #17181a;
          }
        }
        .image-box {
          position: relative;
          img {
            display: block;
            max-width: 100%;
            &.video-play {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate3d(-50%, -50%, 0);
              width: 50px;
              height: 50px;
            }
          }
          cursor: pointer;
        }

        .info {
          padding: 20px 0 12px;
          border-bottom: 1px solid #343538;
          h3.title {
            padding: 0 16px;
            color: #fff;
            flex: 1;
            font-size: 14px;
            font-weight: 400;
            margin: 0;
            text-overflow: ellipsis;
            white-space: nowrapnowrap;
            overflow: hidden;
            text-align: left;
            p {
              display: flex;
              justify-content: flex-end;
              align-items: center;
              margin: 0 0 0 8px;
              i {
                width: 20px;
                height: 20px;
                background: url(../../assets/images/file-size.png) no-repeat;
              }
            }
          }

          p.desc {
            color: #909399;
            margin-top: 10px;
            text-align: left;
            padding: 0 16px;
          }

          .label-list {
            display: flex;
            padding: 0 16px;
            justify-content: flex-start;
            align-items: center;
            margin-top: 10px;
            .label-item {
              padding: 0 8px;
              height: 22px;
              line-height: 22px;
              background-color: #565656;
              color: #c0c4cc;
              font-size: 12px;
              border-radius: 5px;
              margin-right: 10px;

              &.hot-tag {
                width: auto;
                margin: 0 10px 0 0;
                color: #fff;
                border-color: #1983f9;
                background: linear-gradient(
                  135deg,
                  rgba(25, 131, 249, 1) 0%,
                  rgba(112, 48, 255, 1) 100%
                );
                position: relative;

                &:after {
                  position: absolute;
                  right: -8px;
                  top: -7px;
                  content: " ";
                  width: 20px;
                  height: 14px;
                  background: url(../../assets/images/hot-tag-icon.png)
                    no-repeat center center;
                }
              }
            }
          }
        }

        .share {
          padding: 10px 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          i {
            width: 20px;
            height: 20px;
            background: url(../../assets/images/google-icon.png) no-repeat;
            &.facebook {
              background: url(../../assets/images/facebook-icon.png) no-repeat;
            }
          }

          p {
            margin: 0;
            color: #606266;
          }
        }
      }
    }

    .none {
      padding: 100px;
      p {
        color: #606266;
        font-style: 14px;
        margin: 30px 0 0;
      }
    }
  }
}
.label-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;

  .label-item {
    padding: 0 16px;
    height: 22px;
    line-height: 22px;
    margin: 0 8px 8px 0;
    cursor: pointer;

    &.active {
      background-color: #1983f9;
      border-radius: 5px;
      color: #fff;
    }
  }
}
</style>